import { posts } from "assets/data/posts";
import { FeedPost } from "components";
import ReportPostsLayout from "layouts/ReportPostsLayout";

const AntiSocialReports = () => {
    return (
        <ReportPostsLayout
            breadCrumbTitle="Anti Social"
            title="Anti-Social Behavior Posts Reports"
        >
            <>
                {posts.slice(0, 5).map((i) => (
                    <FeedPost post={i} key={i.id} />
                ))}
            </>
        </ReportPostsLayout>
    );
};

export default AntiSocialReports;
